/* React hooks */
import {useEffect, useRef, useState} from "react";
/* Components */
import FormInputs from "../FormInputs";
import {useLocation, useParams} from "react-router-dom";
import {updateUserInfos} from "../../api/admin/userReq";
import useAuth from "../../hooks/useAuth";
import FormButtons from "../../components/common/FormButtons";
import {
    checkPasswordMatch, checkRequiredFields,
    getErrorListFromValidation,
    patternListChoices,
    removeErrorList,
    validateFormInput
} from "../../helper/tools";
import CivilityForm from "../../components/common/input-layout/CivilityForm";
import jwt_decode from "jwt-decode";
import {updateUserProfile} from "../../api/pro/userReq";
import useData from "../../hooks/useData";
import Icon from "../../components/common/Icon";


export default function FormUserInfos({ setShowModal, legend, apiUserInfos }) {
    const { id } = useParams();
    const [values, setValues] = useState();
    const { auth } = useAuth();
    const token = auth.token;
    const decodedToken = jwt_decode(token);
    const profileId = decodedToken.userId;
    const agencyId = decodedToken.agency;
    const { userInfos } = useData();
    let passwordMatch = false;
    const passwordMatchRef = useRef();
    const [ isValid, setIsValid ] = useState("");
    const { pathname } = useLocation();

    const onChange = (e) => {
        setValues({...values, [e.target.name] : e.target.value})
        if (e.target.type === "checkbox") {
            setValues({...values, [e.target.name] : e.target.checked})
        }
        validateFormInput(e)
    };

    useEffect(() => {
        if (checkPasswordMatch(values?.password, values?.passwordConfirm)) {
            setIsValid("valid")
        } else {
            setIsValid("invalid")
        }
    }, [values?.password, values?.passwordConfirm]);

    useEffect(() => {
        setValues(userInfos)
    }, [ userInfos ]);

    const handleRemoveModal = () => {
        setShowModal(false)
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (values?.password && values?.passwordConfirm) {
            passwordMatch = checkPasswordMatch(values?.password, values?.passwordConfirm)
        }
        if (!checkRequiredFields()) {
            return;
        }
        let spanContent = `<p class="error" id="span-content">Les mots de passe ne correspondent pas.</p>`;
        if (!passwordMatch) {
            if (!document.querySelector("#span-content")) {
                passwordMatchRef.current.insertAdjacentHTML("beforebegin", spanContent);
            }
            return;
        } else {
            spanContent = document.querySelector("#span-content");
            if (spanContent) {
                spanContent.remove();
            }
            let userToChangeId = pathname.includes("profil") ? profileId : id ? id : 0;
            let body = {
                userId: userToChangeId,
                agencyId : agencyId,
                civility: values?.civility,
                lastName: values?.lastName,
                firstName: values?.firstName,
                occupation: values?.occupation,
                fixedPhoneNumber: values?.fixedPhoneNumber,
                mobilePhoneNumber: values?.mobilePhoneNumber,
                email: values?.email,
                username: values?.username,
                password: values?.password,
                passwordConfirm: values?.passwordConfirm,
                estimate: values?.estimate
            }
            if (pathname.includes("collaborateurs" || pathname.includes("profil"))) {
                await updateUserInfos(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            setShowModal(false)
                            apiUserInfos()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            } else {
                await updateUserProfile(token, body)
                    .then((response) => {
                        removeErrorList();
                        if (!response?.response?.data?.error) {
                            setShowModal(false)
                            apiUserInfos()
                        } else {
                            getErrorListFromValidation(response?.response?.data?.error)
                        }
                    })
            }
            /*setShowModal(false)*/
        }
    }

    const inputs = [
        {
            id : 1,
            name : "lastName",
            type : "text",
            placeholder : "Nom",
            label : "Nom",
            required : "required",
            pattern: patternListChoices?.lastname
        },
        {
            id : 2,
            name : "firstName",
            type : "text",
            placeholder : "Prénom",
            label : "Prénom",
            required : "required",
            pattern: patternListChoices?.firstname
        },
        {
            id : 3,
            name : "occupation",
            type : "text",
            placeholder : "Fonction",
            label : "Fonction",
            pattern: patternListChoices?.name
        },
        {
            id : 4,
            name : "fixedPhoneNumber",
            type : "text",
            placeholder : "Tél. fixe",
            label : "Tél. fixe",
            pattern: patternListChoices?.phone

        },
        {
            id : 5,
            name : "mobilePhoneNumber",
            type : "text",
            placeholder : "Tél. mobile",
            label : "Tél. mobile",
            pattern: patternListChoices?.phone
        },
        {
            id : 7,
            name : "username",
            type : "text",
            placeholder : "Identifiant",
            label : "Identifiant",
            required : "required",
            pattern: patternListChoices?.name

        },
        {
            id : 8,
            name : "password",
            type : "password",
            value: "",
            placeholder : "Mot de passe",
            label : "Mot de passe",
        },
        {
            id : 9,
            name : "passwordConfirm",
            type : "password",
            value: "",
            placeholder : "Mot de passe (confirmation)",
            label : "Mot de passe (confirmation)",
        },
        {
            id : 6,
            name : "email",
            type : "email",
            placeholder : "Email",
            label : "Email",
            required : "required",
            pattern: patternListChoices?.email
        },
        {
            id: 10,
            name: "estimate",
            type: "checkbox",
            label: "Gestion des devis types",
        }
    ];

    return (
        <form onSubmit={handleSubmit} method="POST" noValidate>
            <fieldset>
                {(legend !== "no-legend") && <Icon source="fa fa-user" span={legend}/>}
                <CivilityForm required value={values?.civility} onChange={onChange}/>
                {inputs.map(input =>(
                    <FormInputs
                        type={ input.type }
                        name={ input.name }
                        id={ input.id }
                        label={input.label}
                        placeholder={ input.placeholder }
                        value={ values?.[input.name] }
                        onChange={ onChange }
                        required={ input.required }
                        options={ input.options }
                        selected={ input.selected }
                        checked={ input.checked }
                        pattern={ input.pattern }
                    />
                ))}
                <div ref={passwordMatchRef}></div>
                <div className="errors"></div>
            </fieldset>
            <FormButtons handleRemoveModal={handleRemoveModal}/>
        </form>
    )
}


